<template>
	<div class="setHeightFullGrey">
		 <van-sticky>
		 <van-tabs v-model="active" @click="onClick"  swipeable title-active-color="#fab13e" color="#fab13e">
		   <van-tab v-for="(item,index) in menu" :name="item" :key="index" :title="item"></van-tab>
		 </van-tabs>
		 </van-sticky>
		 
		 <div v-if="active=='视频资料'" class="paddingXm">
		 	<videoFile></videoFile>
		 </div>
		 <div v-else-if="active=='其他资料'" class="paddingXm">
			 <otherFile></otherFile>
		 </div>
		 
		 <backTop></backTop>
	</div>
</template>

<script>
	import videoFile from '../../publicComponents/video.vue';
	import otherFile from '../../publicComponents/otherFile.vue';
	export default{
		components: {
			"videoFile":videoFile,
			"otherFile":otherFile
		},
		data(){
			return{
				listChildren:[],
				active:'',
				menu:['视频资料','其他资料']
			}
		},
		methods:{
			onClick(name){
				// this.active=name;
				let query='types='+name;
				this.$router.replace('/subPackages/myCenter/file?'+query);
			},
		},
		created() {
			console.log(this.$route);
			this.active=this.$route.query.types;
		}
	}
</script>

<style>
</style>
